import React from "react";
import classes from "./Games.module.css";

function GamesPage() {
    return (
        <>
            <h1 className={classes.GameHeading}>Amazing Games Coming Soon...</h1>
        </>
    );
};
export default GamesPage;